import { Link } from 'react-router-dom';
import { categories, regions, years } from '@/mocks/anime';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            动漫分类
          </h2>
          <p className="text-sm text-foreground-600">按喜好筛选，找到属于你的那一部</p>
        </div>

        <div className="mb-8">
          <h3 className="text-sm font-medium text-foreground-700 mb-3">按类型</h3>
          <div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 border border-transparent hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${
                  cat.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                  cat.color === 'accent' ? 'bg-accent-100 text-accent-700' :
                  'bg-secondary-100 text-secondary-700'
                }`}>
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <span className="text-xs text-foreground-700 group-hover:text-primary-600 whitespace-nowrap font-medium">
                  {cat.name}
                </span>
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <h3 className="text-sm font-medium text-foreground-700 mb-3">按地区</h3>
            <div className="flex flex-wrap gap-2">
              {regions.map((r) => (
                <Link
                  key={r.slug}
                  to={`/category/${r.slug}`}
                  className="px-4 py-1.5 rounded-full bg-background-100 text-foreground-700 text-xs hover:bg-primary-50 hover:text-primary-600 border border-transparent hover:border-primary-200 transition-all cursor-pointer whitespace-nowrap"
                >
                  {r.name}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h3 className="text-sm font-medium text-foreground-700 mb-3">按年份</h3>
            <div className="flex flex-wrap gap-2">
              {years.map((y) => (
                <Link
                  key={y.slug}
                  to={`/category/${y.slug}`}
                  className="px-4 py-1.5 rounded-full bg-background-100 text-foreground-700 text-xs hover:bg-primary-50 hover:text-primary-600 border border-transparent hover:border-primary-200 transition-all cursor-pointer whitespace-nowrap"
                >
                  {y.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}